module.exports = __webpack_public_path__ + "static/media/check-paper-white.9d543bbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/check-paper-white.svg
// module id = 4047
// module chunks = 0